import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import { compose } from 'redux';

import store from '../../store';
import { storesRestHooks } from '../../store/Stores/StoresSlice';
import { useFetchStatus } from '../../utils/fetchStatusUtils';
import ListSkeleton from '../../components/Skeletons/ListSkeleton';
import { transactionsRestHooks } from '../../store/Transactions/TransactionsSlice';
import { cashbacksRestHooks } from '../../store/Cashbacks/CashbacksSlice';

import Transaction from './components/Transaction';

const TransactionContainer = () => {
  const { transactionId } = useParams();
  const history = useHistory();
  const {
    transaction: { loadingStatus, item },
    loadTransaction,
    loadResetTransaction,
    updateTransaction,
    transaction: { errors: transactionErrors },
  } = transactionsRestHooks.use();

  const {
    loadStores,
    loadResetStores,
    stores: { items: stores },
  } = storesRestHooks.use();

  const { isFulfilled } = useFetchStatus(loadingStatus);

  const {
    createCashback,
    deleteCashback,
    cashback: { errors: cashbackErrors },
  } = cashbacksRestHooks.use();

  useEffect(() => {
    loadTransaction(transactionId);
    loadStores();
    return () => {
      loadResetTransaction();
      loadResetStores();
    };
  }, []);

  useEffect(() => {
    const unlisten = () => {
      window.location.reload();
    };
    return () => {
      unlisten();
    };
  }, [history]);

  if (!isFulfilled) {
    return <ListSkeleton />;
  }

  return (
    <Transaction
      transaction={item}
      onCashbackCreate={createCashback}
      onCashbackDelete={deleteCashback}
      onTransactionUpdate={updateTransaction}
      onTransactionLoad={loadTransaction}
      cashbackErrors={cashbackErrors}
      transactionErrors={transactionErrors}
      stores={stores}
    />
  );
};

const addStore = (ProxyComponent) => (props) =>
  (
    <Provider store={store}>
      <ProxyComponent {...props} />
    </Provider>
  );

export default compose(addStore)(TransactionContainer);
